import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";
import { User } from "../../model/login";
import { getSourceByField, SourceItem } from '../../utils/source-utils';
import { HttpClient } from '@angular/common/http';
import * as moment from "moment";

// Resolution item interface
interface ResolutionItem {
  resolution: string;
  resolutionDate: string;
}

@Component({
  selector: "app-new-print-history-body",
  templateUrl: "./new-print-history-body.component.html",
  styleUrls: ["./new-print-history-body.component.scss"],
})
export class NewPrintHistoryBodyComponent implements OnInit {
  searchStringText;
  // Entity and NSL Entity arrays (normalized like pepResult)
  entityResult;
  nslEntityResult;
  pepResult: any[] = [];
  nslResult: any[] = [];
  sanctionResult: any[] = [];
  criminalsSearchResult: any[] = [];
  totalMatches;
  entityTotalMatches;
  typeOfSearch = localStorage.getItem("searchType");
  searchedName = localStorage.getItem("searchedName");
  isAllDBSearch =
    localStorage.getItem("isAllDBSearch") == "true" ? true : false;
  isPepSearch = localStorage.getItem("isPepSearch") == "true" ? true : false;
  isHongKongSearch =
    localStorage.getItem("isHongKongSearch") == "true" ? true : false;
  isInternationalSearch =
    localStorage.getItem("isInternationalSearch") == "true" ? true : false;
  isIndividualSearch =
    localStorage.getItem("isIndividualSearch") == "true" ? true : false;
  isChineseSearch =
    localStorage.getItem("isChineseSearch") == "true" ? true : false;
  userDetails: User;
  isLoading: boolean = true;
  public hongKongDT;
  entityDD = "00";
  entityMM = "00";
  entityYYYY = "0000";
  entityGender = "NO";z
  dailyCounterString = "0000"
  reportData = ""
  showSuccessMsg: boolean = false;
  isSavingRecord: boolean = false
  historyData: any = {}
  reportTime = ""

  // Resolution options
  resolutionOptions = ['--', 'YES', 'NO'];

  // Resolution status for each result type
  sanctionResolutions: { [key: number]: string } = {};
  pepResolutions: { [key: number]: string } = {};
  criminalsResolutions: { [key: number]: string } = {};
  nslResolutions: { [key: number]: string } = {};
  nslEntityResolutions: { [key: number]: string } = {};
  entityResolutions: { [key: number]: string } = {};

  // Resolution dates for each result type
  sanctionResolutionDates: { [key: number]: string } = {};
  pepResolutionDates: { [key: number]: string } = {};
  criminalsResolutionDates: { [key: number]: string } = {};
  nslResolutionDates: { [key: number]: string } = {};
  entityResolutionDates: { [key: number]: string } = {};
  nslEntityResolutionDates: { [key: number]: string } = {};


  // 结构化结果对象
  resolutionResults: {
    sanction: { [key: number]: ResolutionItem };
    pep: { [key: number]: ResolutionItem };
    nsl: { [key: number]: ResolutionItem };
    criminal: { [key: number]: ResolutionItem };
    nslEntity: { [key: number]: ResolutionItem };
    entity: { [key: number]: ResolutionItem };
  } = {
      sanction: {},
      pep: {},
      nsl: {},
      criminal: {},
      nslEntity: {},
      entity: {}
    };

  // Current date for default value
  currentDate = "";

  constructor(private route: ActivatedRoute, private dataService: DataServiceService, private authService: AuthService, private http: HttpClient) {
    // 设置当前日期为默认值
    this.currentDate = moment(new Date()).format('YYYY-MM-DD');

    // if (this.isIndividualSearch) {
      this.historyData = JSON.parse(localStorage.getItem("historyData"));
      try {
        this.isIndividualSearch = this.historyData.isIndividualSearch;
        this.reportData = moment(this.historyData.saveDate, 'DD/MM/YYYY').format('YYYYMMDD');
      } catch (error) {
        console.error('Date parsing error:', error);
        this.reportData = moment().format('YYYYMMDD'); // 使用当前日期作为后备
      }
      try {
        this.reportTime = `${this.historyData.saveDate} ${this.historyData.saveTime}`;
      } catch (error) {
      }
      console.log('historyData', this.historyData)
      this.pepResult = this.historyData.pepResult;
      this.nslResult = this.historyData.nslResult || [];
      this.sanctionResult = this.historyData.sanctionResult;
      this.criminalsSearchResult = this.historyData.criminalsSearchResult;
      this.getDataFromLocalStorage()

    // } else {
    //   // History for entity search
    //   this.historyData = JSON.parse(localStorage.getItem("historyData"));
    //   try {
    //     this.reportData = moment(this.historyData.saveDate, 'DD/MM/YYYY').format('YYYYMMDD');
    //     this.reportTime = `${this.historyData.saveDate} ${this.historyData.saveTime}`;
    //   } catch {}
      // Normalize entity and nslEntity arrays (support object with found_records or raw array)
      this.entityResult = this.historyData?.entityResult || null;
      this.nslEntityResult = this.historyData?.nslEntityResult || null;
    // }
    console.log('this.pepResult', this.pepResult);
    console.log('this.nslResult', this.nslResult);
    console.log('this.sanctionResult', this.sanctionResult);
    console.log('this.criminalsSearchResult', this.criminalsSearchResult);
    console.log('this.entityResult', this.entityResult);
    console.log('this.nslEntityResult', this.nslEntityResult);
    this.totalMatches = this.sanctionResult.length + this.pepResult.length + this.criminalsSearchResult.length + this.nslResult.length
    this.entityTotalMatches = this.entityResult?.found_records?.length || 0 + this.nslEntityResult?.found_records?.length || 0
    this.handleCriminalsSearchResult()

    // Initialize resolutions
    if (this.sanctionResult) {
      this.sanctionResult.forEach((item, index) => {
        // 不管条件如何，直接读取原始值
        // 对于resolution，如果没有值则设为默认值
        this.sanctionResolutions[index] = item.resolution || '--';
        if (!item.resolution) {
          item.resolution = '--';
        }

        // 对于resolutionDate，如果没有值则设为默认值
        this.sanctionResolutionDates[index] = item.resolutionDate || "";
        //         if (!item.resolutionDate) {
        //           item.resolutionDate = this.currentDate;
        //         }

        // 更新结果对象
        this.resolutionResults.sanction[index] = {
          resolution: item.resolution,
          resolutionDate: item.resolutionDate || ""
        };

        console.log(`Sanction ${index} resolution: ${item.resolution}, date: ${item.resolutionDate}`);
      });
    }

    if (this.pepResult) {
      this.pepResult.forEach((item, index) => {
        // 不管条件如何，直接读取原始值
        // 对于resolution，如果没有值则设为默认值
        this.pepResolutions[index] = item.resolution || '--';
        if (!item.resolution) {
          item.resolution = '--';
        }

        // 对于resolutionDate，如果没有值则设为默认值
        this.pepResolutionDates[index] = item.resolutionDate || "";
        //         if (!item.resolutionDate) {
        //           item.resolutionDate = this.currentDate;
        //         }

        // 更新结果对象
        this.resolutionResults.pep[index] = {
          resolution: item.resolution,
          resolutionDate: item.resolutionDate || ""
        };

        console.log(`PEP ${index} resolution: ${item.resolution}, date: ${item.resolutionDate}`);
      });
    }

    if (this.criminalsSearchResult) {
      this.criminalsSearchResult.forEach((item, index) => {
        // 不管条件如何，直接读取原始值
        // 对于resolution，如果没有值则设为默认值
        this.criminalsResolutions[index] = item.resolution || '--';
        if (!item.resolution) {
          item.resolution = '--';
        }

        // 对于resolutionDate，如果没有值则设为默认值
        this.criminalsResolutionDates[index] = item.resolutionDate || "";
        //         if (!item.resolutionDate) {
        //           item.resolutionDate = this.currentDate;
        //         }

        // 更新结果对象
        this.resolutionResults.criminal[index] = {
          resolution: item.resolution,
          resolutionDate: item.resolutionDate || ""
        };

        console.log(`Criminal ${index} resolution: ${item.resolution}, date: ${item.resolutionDate}`);
      });
    }

    // Initialize NSL (individual) resolutions from history data if present
    if (this.nslResult) {
      this.nslResult.forEach((item, index) => {
        this.nslResolutions[index] = item.resolution || '--';
        if (!item.resolution) {
          item.resolution = '--';
        }
        this.nslResolutionDates[index] = item.resolutionDate || '';
      });
    }


    // Initialize nslEntity resolutions
    if (this.nslEntityResult && this.nslEntityResult.found_records) {
      this.nslEntityResult.found_records.forEach((item, index) => {
        this.nslEntityResolutions[index] = '--';
        this.nslEntityResolutionDates[index] = "";
        this.resolutionResults.nslEntity[index] = {
          resolution: '--',
          resolutionDate: ""
        };
        // 直接存储在nslEntityResult对象中
        item.resolution = '--';
        item.resolutionDate = "";
      });
    }

    // Initialize entity resolutions
    if (this.entityResult && this.entityResult.found_records) {
      this.entityResult.found_records.forEach((item, index) => {
        this.entityResolutions[index] = '--';
        this.entityResolutionDates[index] = "";
        this.resolutionResults.entity[index] = {
          resolution: '--',
          resolutionDate: ""
        };
        // 直接存储在entityResult对象中
        item.resolution = '--';
        item.resolutionDate = "";
      });
    }
  }


  ngOnInit(): void {
    // 设置当前日期，用于限制日期选择器的最大值
    this.currentDate = new Date().toISOString().split("T")[0]; // 格式为 YYYY-MM-DD

    this.hongKongDT = this.historyData.hongKongDT;
    if (this.isIndividualSearch) {
      this.searchStringText =
        this.typeOfSearch != "advance"
          ? `NEW QUICK SEARCH RESULTS FOR ${this.historyData.searchedName}`
          : `NEW ADVANCE SEARCH RESULTS FOR ${this.historyData.searchedName}`;
    } else {
      this.searchStringText = `NEW ENTITY SEARCH RESULTS FOR ${this.historyData.searchedName}`;
    }
    this.getUserDetails().then((data) => {
      this.isLoading = false;
    });
  }

  async handleCriminalsSearchResult() {
    console.log("handleCriminalsSearchResult")
    if (this.criminalsSearchResult && this.criminalsSearchResult.length > 0) {
      for (let index = 0; index < this.criminalsSearchResult.length; index++) {
        const element = this.criminalsSearchResult[index];
        element.sourceInfo = await getSourceByField(element.source_id, this.http);
        console.log('element.sourceInfo', element.sourceInfo);
      }
    }
  }

  async getUserDetails() {
    this.userDetails = await this.dataService.getUserDetailsById(
      this.authService.getCurrentUser().userId
    );
    this.userDetails = this.userDetails[0];
    console.log('new-print-body.component userDetails', this.userDetails);
  }

  getDataFromLocalStorage() {
    this.entityDD = this.historyData.entityDD
    this.entityYYYY = this.historyData.entityYYYY
    this.entityMM = this.historyData.entityMM
    this.entityGender = this.historyData.entityGender
    this.dailyCounterString = this.historyData.dailyCounterString && this.historyData.dailyCounterString > 0
      ? this.historyData.dailyCounterString
      : "0000";
  }

  /**
   * Formats a number as a 4-digit string with leading zeros
   * @param counter The number to format (e.g., 0, 1, 42, etc.)
   * @returns A 4-digit string with leading zeros (e.g., "0000", "0001", "0042", etc.)
   */
  formatDailyCounter(counter: number): string {
    // Convert the number to string and pad with leading zeros to make it 4 digits
    return counter.toString().padStart(4, '0');
  }

  saveRecord() {
    // 如果已经在保存记录中，则直接返回，防止重复点击
    if (this.isSavingRecord) {
      console.log("Save in progress, ignoring duplicate request");
      return;
    }
    console.log("saveRecord")
    console.log("saveRecord")
    this.isSavingRecord = true
    var currentDate = new Date()
    var historyObj = {}

    historyObj['userEmail'] = this.userDetails.email;
    let recordJson = {
      pepResult: this.pepResult,
      nslResult: this.nslResult,
      sanctionResult: this.sanctionResult,
      criminalsSearchResult: this.criminalsSearchResult,
      entityResult: this.entityResult,
      nslEntityResult: this.nslEntityResult,
      // totalMatches: this.totalMatches,
      totalMatches: this.isIndividualSearch ? this.totalMatches : this.entityTotalMatches,
      typeOfSearch: this.historyData.typeOfSearch,
      searchedName: this.historyData.searchedName,
      hongKongDT: this.hongKongDT,
      entityGender: this.entityGender,
      entityDD: this.entityDD,
      entityMM: this.entityMM,
      entityYYYY: this.entityYYYY,
      dailyCounterString: this.dailyCounterString,
      todayName: this.historyData.saveDate,
      resolutionResults: this.resolutionResults
    }
    recordJson['saveDate'] = this.historyData && this.historyData.saveDate ? this.historyData.saveDate : ""
    recordJson['saveTime'] = this.historyData && this.historyData.saveTime ? this.historyData.saveTime : ""
    recordJson['UTCsaveDate'] = `${currentDate.getUTCDate()}/${currentDate.getUTCMonth() + 1}/${currentDate.getUTCFullYear()}`;
    recordJson['UTCsaveTime'] = `${currentDate.getUTCHours()}:${currentDate.getUTCMinutes()}:${currentDate.getUTCSeconds()}`;
    recordJson['type'] = 'REPORT'

    historyObj['historyData'] = [recordJson]
    console.log('historyObj', historyObj);
    this.dataService.saveSearchResult(historyObj)
      .then((data) => {
        if (data['msg'] == 'Saved record') {
          this.isSavingRecord = false
          this.showSuccessMsg = true;
          setTimeout(() => {
            this.showSuccessMsg = false;
          }, 5000);
        }
        else {
          this.isSavingRecord = false; // 在失败时也需要重置保存状态
          alert('Failed to save record. Please try after some time')
        }
      })
      .catch((error) => {
        console.error("Error saving record:", error);
        this.isSavingRecord = false; // 发生错误时重置保存状态
        alert("An error occurred while saving. Please try again later.");
      });
  }

  /**
   * Change the resolution status for a specific result
   * @param type The type of resu/new-print-historylt ('sanction', 'pep', 'criminal')
   * @param index The index of the result
   * @param value The new resolution value
   */
  changeResolution(type: string, index: number, value: string): void {
    console.log(`Changing ${type} resolution at index ${index} to ${value}`);

    switch (type) {
      case 'sanction':
        this.sanctionResolutions[index] = value;
        this.resolutionResults.sanction[index].resolution = value;
        // 直接存储在sanctionResult对象中
        this.sanctionResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === 'NO' || value === '--') {
          this.sanctionResolutionDates[index] = '';
          this.resolutionResults.sanction[index].resolutionDate = '';
          this.sanctionResult[index].resolutionDate = '';
        }
        break;
      case 'pep':
        this.pepResolutions[index] = value;
        this.resolutionResults.pep[index].resolution = value;
        // 直接存储在pepResult对象中
        this.pepResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === 'NO' || value === '--') {
          this.pepResolutionDates[index] = '';
          this.resolutionResults.pep[index].resolutionDate = '';
          this.pepResult[index].resolutionDate = '';
        }
        break;
      case 'criminal':
        this.criminalsResolutions[index] = value;
        this.resolutionResults.criminal[index].resolution = value;
        // 直接存储在criminalsSearchResult对象中
        this.criminalsSearchResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === 'NO' || value === '--') {
          this.criminalsResolutionDates[index] = '';
          this.resolutionResults.criminal[index].resolutionDate = '';
          this.criminalsSearchResult[index].resolutionDate = '';
        }
        break;
      case 'nsl':
        this.nslResolutions[index] = value;
        // 直接存储在nslResult对象中
        this.nslResult[index].resolution = value;

        // 如果选择了"NO"或"--"，清空日期值
        if (value === 'NO' || value === '--') {
          this.nslResolutionDates[index] = '';
          this.nslResult[index].resolutionDate = '';
        }
        break;
        case 'nslEntity':
          this.nslEntityResolutions[index] = value;
          this.resolutionResults.nslEntity[index].resolution = value;
          // 直接存储在nslEntityResult对象中
          this.nslEntityResult.found_records[index].resolution = value;
  
          // 如果选择了"NO"或"--"，清空日期值
          if (value === 'NO' || value === '--') {
            this.nslEntityResolutionDates[index] = '';
            this.resolutionResults.nslEntity[index].resolutionDate = '';
            this.nslEntityResult.found_records[index].resolutionDate = '';
          }
          break;
        case 'entity':
          this.entityResolutions[index] = value;
          this.resolutionResults.entity[index].resolution = value;
          // 直接存储在entityResult对象中
          this.entityResult.found_records[index].resolution = value;
  
          // 如果选择了"NO"或"--"，清空日期值
          if (value === 'NO' || value === '--') {
            this.entityResolutionDates[index] = '';
            this.resolutionResults.entity[index].resolutionDate = '';
            this.entityResult.found_records[index].resolutionDate = '';
          }
          break;
    }

    // 记录当前所有结果
    console.log('Sanction Result:', this.sanctionResult);
    console.log('PEP Result:', this.pepResult);
    console.log('Criminals Result:', this.criminalsSearchResult);
  }

  /**
   * Change the resolution date for a specific result
   * @param type The type of result ('sanction', 'pep', 'criminal')
   * @param index The index of the result
   * @param date The new date value
   */
  changeResolutionDate(type: string, index: number, date: string): void {
    console.log(`Changing ${type} resolution date at index ${index} to ${date}`);

    switch (type) {
      case 'sanction':
        this.sanctionResolutionDates[index] = date;
        this.resolutionResults.sanction[index].resolutionDate = date;
        // 直接存储在sanctionResult对象中
        this.sanctionResult[index].resolutionDate = date;
        break;
      case 'pep':
        this.pepResolutionDates[index] = date;
        this.resolutionResults.pep[index].resolutionDate = date;
        // 直接存储在pepResult对象中
        this.pepResult[index].resolutionDate = date;
        break;
      case 'criminal':
        this.criminalsResolutionDates[index] = date;
        this.resolutionResults.criminal[index].resolutionDate = date;
        // 直接存储在criminalsSearchResult对象中
        this.criminalsSearchResult[index].resolutionDate = date;
        break;
      case 'nsl':
        this.nslResolutionDates[index] = date;
        // 直接存储在nslResult对象中
        this.nslResult[index].resolutionDate = date;
        break;
      case 'entity':
        this.entityResolutionDates[index] = date;
        if (this.entityResult && this.entityResult[index]) {
          this.entityResult[index].resolutionDate = date;
        }
        break;
      case 'nslEntity':
        this.nslEntityResolutionDates[index] = date;
        if (this.nslEntityResult && this.nslEntityResult[index]) {
          this.nslEntityResult[index].resolutionDate = date;
        }
        break;
    }

    // 记录当前所有结果
    console.log('Sanction Result:', this.sanctionResult);
    console.log('PEP Result:', this.pepResult);
    console.log('Criminals Result:', this.criminalsSearchResult);
  }

  /**
   * 获取所有Resolution结果
   * 在保存记录时可以调用此方法获取完整的结果数据
   */
  getAllResolutionResults() {
    return this.resolutionResults;
  }
}
